import React, { Fragment, useState } from 'react'
import { Card, Col, Row, Modal, Button } from 'antd';
import { Div, Title, SubTitle, DivTitle, Descripcion} from './styles';
import './modal.css'

export const Blog = () => {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const showModal = ( message ) => {
    setContent(message.message);
    setTitle(message.title);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const messages = [
    {
      id: 1,
      title: '¿Cómo mantener tu cabello hidratado?',
      description: 'Si queremos hidratar nuestro cabello es importante...',
      message: 'Si queremos hidratar nuestro cabello es importante bla bla bla Si queremos hidratar nuestro cabello es importante bla bla bla Si queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla blaSi queremos hidratar nuestro cabello es importante bla bla bla',
      urlImage: require('./images/imagen1.png')
    },
    {
      id: 2,
      title: 'Funcionalidad de los activos en nuestros productos',
      description: 'Queremos cuidarte y que estés tranquil@ con nuestros productos, así que te detallamos...',
      message: 'Queremos cuidarte y que estés tranquil@ con nuestros productos, así que te detallamos bla bla bla',
      urlImage: require('./images/imagen2.png')
    },
    {
      id: 3,
      title: '10 Tips para tener una piel sana',
      description: 'Es importante cuidar y mantener sano nuestro templo, así que a continuación te damos los siguientes...',
      message: 'Es importante cuidar y mantener sano nuestro templo, así que a continuación te damos los siguientes bla bla bla',
      urlImage: require('./images/imagen3.png')
    }
  ]

    return (
      <Fragment>
        <Modal title={title} 
          visible={isModalVisible} 
          onOk={handleOk} 
          onCancel={handleOk}
          className='modalStyle'
          width={2000}
          closable={false}
          footer={[
            <Button key="back" onClick={handleOk} style={{ background: '#9A8313', color: '#fff' }}>
              Cerrar
            </Button>
          ]}>
          <p>{content}</p>
        </Modal>
        <Div>
          <DivTitle>
            <Title>Blog</Title>
            <SubTitle>Acá podrás encontrar información importante que debes tener en cuenta para tu cuidado personal.</SubTitle>
          </DivTitle>
            <Row gutter={[40, 40]}>
            {messages.map(message => 
                <Col span={8} xs={{ span: 24  }} md={{ span: 8 }} key={message.id}>
                  <Card 
                      bordered={false}
                      hoverable
                      cover={<img alt="example" src={message.urlImage} />}
                      onClick={() => showModal(message)}
                  >
                    <Descripcion title={message.title} description={message.description}/>
                  </Card>
                </Col>
              )}
            </Row>
          </Div>
      </Fragment>
    )
  }